import styled, { css } from "styled-components";

export const ToggleWrapper = styled.div`
	display: inline-flex;
	padding: 3px;
	border-radius: 50px;
	background: var(--input-bg-has-value);
	border: 1px solid rgba(110, 113, 145, 0.15);
	gap: 2px;
`;

export const ToggleButton = styled.button`
	border: none;
	border-radius: 50px;
	padding: 7px 16px;
	font-size: 11px;
	font-weight: 700;
	cursor: pointer;
	background: transparent;
	color: var(--secondary-text-color);
	transition: all 0.2s ease;
	letter-spacing: 0.3px;
	text-transform: uppercase;

	${({ $active }) =>
		$active &&
		css`
			background: var(--content-text-color);
			color: var(--profile-page-wrapper-bg);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
		`}

	&:hover:not(:disabled) {
		color: var(--content-text-color);
	}
`;
